import { createServiceToken } from '@/app/di';
import type { ClinicsService } from './infrastructure/clinics.service';
import type { UsersService } from './infrastructure/users.service';

export const CLINICS_SERVICE = createServiceToken<ClinicsService>('ClinicsService');
export const USERS_SERVICE = createServiceToken<UsersService>('UsersService');
